import { render, staticRenderFns } from "./SubstanceListPropertiesEditor.vue?vue&type=template&id=3424e648&scoped=true&"
import script from "./SubstanceListPropertiesEditor.vue?vue&type=script&lang=js&"
export * from "./SubstanceListPropertiesEditor.vue?vue&type=script&lang=js&"
import style0 from "./SubstanceListPropertiesEditor.vue?vue&type=style&index=0&id=3424e648&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3424e648",
  null
  
)

export default component.exports